import { createStyles } from '../../../styles';
export default createStyles((theme, { padding }) => {
    return {
        root: {
            display: 'block',
            marginLeft: -1 * theme.fn.size({ size: padding, sizes: theme.space }),
            marginRight: -1 * theme.fn.size({ size: padding, sizes: theme.space })
        }
    };
});
